import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';
const ACTIONS = {
    GET_MY_RECOMMEND_TAGS_SUCCESS: 'GET_MY_RECOMMEND_TAGS_SUCCESS',
    GET_MY_RECOMMEND_TAGS_ERROR: 'GET_MY_RECOMMEND_TAGS_ERROR',
};

const updateStatus = (type, data) => ({
  type,
  data,
});

const getTags = () => {
    const config = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`
        }
      };
      let url = `${host.recommend_server}measure_tag`;
      return (dispatch) => {
        return new Promise((resolve, reject) => {  // Return a promise from the action creator
            callApi(url, config,
                (data) => {
                    dispatch(updateStatus(ACTIONS.GET_MY_RECOMMEND_TAGS_SUCCESS, data));
                    resolve(data);  // Resolve the promise with the data
                },
                (err) => {
                    dispatch(updateStatus(ACTIONS.GET_MY_RECOMMEND_TAGS_ERROR, err));
                    reject(err);  // Reject the promise on error
                });
        });
    };
};

export {
    ACTIONS, getTags
};
